import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Container, Typography, Box, Grid, Button, Tabs, Tab } from "@mui/material";
import CarImageSlider from "./CarImageSlider";

const CarDetails = () => {
  const { id } = useParams();
  const [car, setCar] = useState(null);
  const [shopeDetails, setShopeDetails] = useState([]);
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    fetch("/assets/carData/shopDetails.json")
      .then((res) => res.json())
      .then((data) => setShopeDetails(data))
      .catch((err) => console.error("Failed to fetch shop data", err));
  }, []);

  useEffect(() => {
    fetch("/assets/carData/carData.json")
      .then((res) => res.json())
      .then((data) => {
        const selectedCar = data.find((item) => item.id === parseInt(id));
        setCar(selectedCar);
      })
      .catch((err) => console.error("Failed to fetch car details:", err));
  }, [id]);

  if (!car) {
    return (
      <Typography variant="h6" align="center" mt={5}>
        Loading car details...
      </Typography>
    );
  }

  return (
    <Container sx={{ mt: 4 }}>
      <Box>
        <Typography variant="h4" gutterBottom>
          {car.make} - {car.model} -{" "}
          {car.price.toLocaleString("en-IN", {
            style: "currency",
            currency: "INR",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          })}
        </Typography>

        <Grid container justifyContent="center" spacing={4}>
          <Grid item xs={12} md={10}>
            <CarImageSlider images={car.images} />
          </Grid>

          <Grid item xs={12}>
            <Box
              sx={{
                backgroundColor: "#232628",
                borderLeft: "4px solid #232628",
                borderRight: "4px solid #232628",
              }}
            >
              <Tabs
                value={tabIndex}
                onChange={(e, newVal) => setTabIndex(newVal)}
                TabIndicatorProps={{ style: { display: "none" } }}
                variant="scrollable"
                scrollButtons="auto"
                sx={{
                  "& .MuiTab-root": {
                    color: "#f7f7f7",
                    fontWeight: "bold",
                    textTransform: "uppercase",
                    px: 3,
                  },
                  "& .Mui-selected": {
                    backgroundColor: "#fff",
                    color: "#000",
                    borderLeft: "4px solid #d86f19",
                  },
                }}
              >
                <Tab label="Description" />
                <Tab label="Specifications" />
                <Tab label="Contact" />
              </Tabs>
            </Box>

            <Box mt={3}>
              {tabIndex === 0 && (
                <Typography>{car.description || "No description available."}</Typography>
              )}

              {tabIndex === 1 && (
                <>
                  <Typography><strong>Make:</strong> {car.make}</Typography>
                  <Typography><strong>Model:</strong> {car.model}</Typography>
                  <Typography><strong>Body Type:</strong> {car.bodyType}</Typography>
                  <Typography><strong>Fuel Type:</strong> {car.fuel}</Typography>
                  <Typography><strong>Year:</strong> {car.year}</Typography>
                  <Typography><strong>Color:</strong> {car.color}</Typography>
                  <Typography><strong>Transmission:</strong> {car.transmission}</Typography>
                  <Typography><strong>Kilometers Driven:</strong> {car.mileage}</Typography>
                </>
              )}

              {tabIndex === 2 && (
                <>
                  <Typography><strong>Get in Touch:</strong></Typography>
                  <Button
                    className="car-card-button whatsapp"
                    aria-label="Contact via WhatsApp"
                    onClick={() => {
                      const message = `Hi, I'm interested in the ${car.name} (${car.year}, ${car.fuel}, ${car.transmission}, ₹${car.price}L). 
Here's the link: ${window.location.origin}/car-details/${car.id}
Could you please share more details?`;

                      const phoneNumber = shopeDetails[0]?.whatsapp || "";
                      const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
                        message
                      )}`;

                      window.open(whatsappURL, "_blank");
                    }}
                  >
                    <img src="/assets/icon/whatsappSVG.svg" alt="WhatsApp" width={25} />
                  </Button>

                  <Button
                    className="car-card-button call"
                    aria-label="Call now"
                    onClick={() => {
                      window.location.href = "tel:" + shopeDetails[0]?.phone;
                    }}
                  >
                    <img src="/assets/icon/call-supportSVG.svg" alt="Call" width={25} />
                  </Button>
                </>
              )}
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default CarDetails;
